<ion-app>
  <admin-header></admin-header>
  <ion-router-outlet id="main-content"></ion-router-outlet>
  <admin-toast-host></admin-toast-host>
</ion-app>
